import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
export const getFinalBookingQuote = createServerFn({ method: "GET" })
  .inputValidator(z.object({ id: z.string().regex(/^\d{1,12}$/), date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), startTimeId: z.string().nullable().optional(), rateId: z.string().nullable().optional(), items: z.array(z.object({ pricingCategoryId: z.string().regex(/^\d{1,12}$/), quantity: z.number().int().min(0).max(100) })).max(12), currency: z.enum(["MXN","USD","EUR","GBP","CAD"]), pickupPlaceId:z.string().nullable().optional(),dropoffPlaceId:z.string().nullable().optional() }))
  .handler(async ({ data }) => {
    const { assertPublicBokunId } = await import("./public-catalog-guard.server");
    await assertPublicBokunId(data.id);
    const { quoteFinalSelection } = await import("./bokun-final-quote.server");
    try { return { ok: true as const, ...await quoteFinalSelection(data) }; }
    catch { return { ok: false as const }; }
  });

export const getFinalReferencePrice = createServerFn({ method: "GET" })
  .inputValidator(z.object({ id:z.string().regex(/^\d{1,12}$/),currency:z.enum(["MXN","USD","EUR","GBP","CAD"]).default("MXN") }))
  .handler(async ({data}) => {
    const { assertPublicBokunId } = await import("./public-catalog-guard.server");
    await assertPublicBokunId(data.id);
    const { quoteReferencePrice } = await import("./bokun-final-quote.server");
    try { return await quoteReferencePrice(data.id,data.currency); } catch { return null; }
  });